/**
 * Evident color CSS variable names (must match src/style-configs/evidentColors.scss).
 * Used by ColorsExample to render and copy variable names.
 */

export interface ColorTheme {
    name: string;
    variables: readonly string[];
}

export const EVIDENT_COLOR_THEMES: readonly ColorTheme[] = [
    {
        name: 'Green',
        variables: [
            '--eidGreen',
        ],
    },
    {
        name: 'Trust Green',
        variables: [
            '--eidTrustGreen',
            '--eidTrustGreen-75',
            '--eidTrustGreen-50',
            '--eidTrustGreen-25',
            '--eidTrustGreen-10',
        ],
    },
    {
        name: 'Success Green',
        variables: [
            '--eidSuccessGreen',
            '--eidSuccessGreen-75',
            '--eidSuccessGreen-50',
            '--eidSuccessGreen-25',
            '--eidSuccessGreen-10',
        ],
    },
    {
        name: 'Impact Orange',
        variables: [
            '--eidImpactOrange',
            '--eidImpactOrange-75',
            '--eidImpactOrange-50',
            '--eidImpactOrange-25',
            '--eidImpactOrange-10',
        ],
    },
    {
        name: 'Warning Yellow',
        variables: [
            '--eidWarningYellow',
            '--eidWarningYellow-75',
            '--eidWarningYellow-50',
            '--eidWarningYellow-25',
            '--eidWarningYellow-10',
        ],
    },
    {
        name: 'Danger Red',
        variables: [
            '--eidDangerRed',
            '--eidDangerRed-75',
            '--eidDangerRed-50',
            '--eidDangerRed-25',
            '--eidDangerRed-10',
        ],
    },
    {
        name: 'Safety Blue',
        variables: [
            '--eidSafetyBlue',
            '--eidSafetyBlue-75',
            '--eidSafetyBlue-50',
            '--eidSafetyBlue-25',
            '--eidSafetyBlue-10',
        ],
    },
    {
        name: 'Dark Blue',
        variables: [
            '--eidDarkBlue',
            '--eidDarkBlue-75',
            '--eidDarkBlue-50',
        ],
    },
    {
        name: 'Secure Blue',
        variables: [
            '--eidSecureBlue',
            '--eidSecureBlue-75',
            '--eidSecureBlue-50',
            '--eidSecureBlue-25',
            '--eidSecureBlue-10',
        ],
    },
    {
        name: 'Quality Black',
        variables: [
            '--eidQualityBlack',
            '--eidQualityBlack-75',
            '--eidQualityBlack-50',
            '--eidQualityBlack-25',
            '--eidQualityBlack-10',
        ],
    },
    {
        name: 'Tech Gray',
        variables: [
            '--eidTechGray',
            '--eidTechGray-75',
            '--eidTechGray-50',
            '--eidTechGray-25',
            '--eidTechGray-10',
        ],
    },
    {
        name: 'Light Gray',
        variables: [
            '--eidLightGray',
            '--eidLightGray-75',
            '--eidLightGray-50',
            '--eidLightGray-25',
        ],
    },
    {
        name: 'Background Gray Tones',
        variables: [
            '--eidBgGrayTones-lighter',
            '--eidBgGrayTones-lightest',
        ],
    },
    {
        name: 'White',
        variables: [
            '--eidWhite',
        ],
    },
] as const;

/**
 * Flattened array of all color variables for backward compatibility.
 */
export const EVIDENT_COLOR_VARIABLES = EVIDENT_COLOR_THEMES.flatMap((theme) => theme.variables) as readonly string[];
